import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propNumber } from '../../../../helpers/custom-prop-types';
import ProffitMartRecommended from '../../../ProffitMart/ProffitMartRecommended';
const ConsultantSearchListFooter = (props) => {
    const { sendPickup, totalCount } = props;
    if (totalCount === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'search_list_footer' }, { children: _jsx("div", Object.assign({ className: 'mb3 search_list_footer_form' }, { children: _jsx(ProffitMartRecommended, { form: 'ConsultantSearch_Footer', forSearchConsultant: true, onSubmit: sendPickup }) })) })));
};
ConsultantSearchListFooter.propTypes = {
    sendPickup: propFunc().isRequired,
    totalCount: propNumber().isRequired,
};
export default ConsultantSearchListFooter;
